<template>
    
    <div class="">
        <div class="header" v-show="!collageBox">
            <div class="header-wrapper">
                <div class="header-title">
                    智能云算力资源交易平台
                </div>
                <div class="header-menu">
                    <ul>
                        <li  
                            v-for="(item, index) in headerMenuList" 
                            :key="index" 
                            class="header-menu-item"
                            :class="{'active':headerActive === item.activeTab}"
                            @click="handleClick(item)" 
                        >
                            {{ item.text }}
                        </li>
                    </ul>
                </div>
                <div class="header-islogin">
                    <div v-if="!isLogin" class="header-menu-login">
                        <button class="login-btn" @click="handleLogin">登录</button>
                        <button class="register-btn" @click="handleRegister">注册</button>
                    </div>

                    <div v-if="isLogin"  class="header-el-dropdown-menu">
                        <el-dropdown @command="handleCommand">
                            <span class="el-dropdown-link">
                                {{ userInfo }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <template v-if="cloud_login_user_role == 1">
                                    <el-dropdown-item command="demandUser">个人中心</el-dropdown-item>
                                </template>
                                <template v-if="cloud_login_user_role == 2">
                                    <el-dropdown-item command="demandUser">个人中心</el-dropdown-item>
                                </template>
                                <template v-if="cloud_login_user_role == 3">
                                    <el-dropdown-item command="resourceUser">个人中心</el-dropdown-item>
                                </template>
                                <template v-if="cloud_login_user_role == 4">
                                    <el-dropdown-item command="channelUser">个人中心</el-dropdown-item>
                                </template>
                                <el-dropdown-item divided command="out">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="collageBox">
            <div class="header-navbar">
                <div class="header-navbar-lt">智能云算力资源交易平台</div>
                <div class="header-navbar-rt" @click="handleCollage">
                    <i class="el-icon-s-operation"></i>
                </div>
            </div>
            <el-drawer
                title="我是标题"
                :visible.sync="drawerCollage"
                :append-to-body="true"
                size="50%"
                :with-header="false">
                <div class="header-menu-drawer">
                    <ul>
                        <li  
                            v-for="(item, index) in headerMenuList" 
                            :key="index" 
                            class="header-menu-item"
                            :class="{'active':headerActive === item.activeTab}"
                            @click="handleClick(item)" 
                        >
                            {{ item.text }}
                        </li>
                    </ul>
                    <div class="header-mobile-login" v-if="!isLogin">
                        <button class="mobile-btn" @click="handleMobileLogin">登录</button>
                        <button class="mobile-btn" @click="handleMobileRegister">注册</button>

                        <!-- <van-button type="default">信息按钮</van-button> -->
                    </div>
                    <div class="header-mobile-login" v-if="isLogin">
                        <!-- <button class="login-btn" @click="handleLogin">登录</button> -->
                        <div>{{ userInfo }}</div>
                        <div style="color:#303133" @click="loginOut">退出登录</div>
                    </div>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            collageBox:false,
            drawerCollage:false ,
            isLogin: false,
            headerActive:0,
            headerMenuList: [
                { text: '首页',     activeTab: 0, address: '/'},
                { text: '资源市场', activeTab: 3, address: '/resources'},
                { text: '需求市场', activeTab: 4, address: '/demand'},
                { text: '行业新闻', activeTab: 1, address: '/news'},
                { text: '通知公告', activeTab: 2, address: '/notice'},
                
            ],
            userInfo: '',
            // cloud_login_user_role:"",
            cloud_login_user_role:sessionStorage.getItem('cloud_login_user_role'),//用户权限 /1个人需求 2公司需求 3资源 4渠道
        };
    },
    created() {
        let token = sessionStorage.getItem('cloud_login_token');
        let userName = sessionStorage.getItem('cloud_login_name');
        if (userName) {
            this.userInfo = userName;
        }
        if (token) {
            this.isLogin = true;
        }
    },
    watch: {
        '$store.state.token': function (newVal) {
            let token = newVal;
            let userName = sessionStorage.getItem('cloud_login_name');
            if (userName) {
                this.userInfo = userName;
                this.cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');
            }
            if (token) {
                this.isLogin = true;
            }
        },
    },
    mounted(){
        // 根据URL hash 设置初始激活项
        const hash = window.location.hash.substring(1);
        
        this.headerMenuList.forEach(item=>{
            if(hash == item.address){
                this.headerActive = item.activeTab;
            }
        })

        // 获取当前屏幕的宽度 
        // 加载不同的header 
        // console.log(window.innerWidth);
        if(window.innerWidth < 1000){
            this.collageBox = true;
        }else{
            this.collageBox = false;
        }

    },
    methods: {
        handleCollage(){
            this.drawerCollage = !this.drawerCollage;

        },
        handleClickExit() {
            sessionStorage.removeItem('cloud_login_userInfo');
            sessionStorage.removeItem('cloud_login_token');
            this.show = true;
            this.isLogin = false;
        },
        // 登录
        handleLogin() {
            this.$store.commit('SET_LOGIN_DIALOG_STATE', true);
        },
        //注册
        handleRegister() {
            this.$store.commit('SET_REGISTER_DIALOG_STATE', true);
        },

        
        handleClick(item) {
            this.headerActive = item.activeTab;
            this.$router.push({path:item.address});
            
        },
        gotoHome() {
            let query = '/';
            this.$router.push(query);
        },
        handleCommand(command) {
            if (command == 'out') {
                sessionStorage.clear();
                this.show = true;
                this.isLogin = false;
                this.$router.push('/');
            } else if(command == 'demandUser'){
                this.$router.push({path:'/demandUser'});
            } else if(command == 'resourceUser'){
                this.$router.push({path:'/resourceUser'});
            }else if(command == 'channelUser'){
                this.$router.push({path:'/channelUser'});
            }
        },
        handleMobileLogin(){
            this.$router.push({ path: '/mobileLogin' });
        },
        handleMobileRegister(){
            this.$router.push({ path: '/mobileRegister' });
        },

        loginOut(){
            sessionStorage.clear();
            this.isLogin = false;
            this.drawerCollage = false;
        }
    },
};
</script>

<style lang="scss" scoped>
.header {
    height: 4rem;
    display: flex;
    justify-content: center;
}
.header-wrapper {
    width: 70%;
    height: 100%;
    display: flex;
    justify-content: space-between;
}
.header-title {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    line-height: 100%;
    font-weight: bold;
    color: rgb(92, 92, 92);
    text-shadow: 0.4rem 0.4rem 0.4rem #c0c0c0;
    cursor:default;
    // img {
    //     width: 2.8rem;
    //     height: 2.5rem;
    //     margin-right: 1rem;
    //     cursor: pointer;
    // }
}
.header-menu {
    // border: 1px solid red;
    display: flex;
    align-items: center;
    // position: relative;
    ul,
    li {
        padding: 0;
        margin: 0;
    }
    ul {
        display: flex;
        align-items: center;
    }
    li{
        list-style: none;
    }
    .header-menu-item {
        color: #1e1e1e;
        padding: 1rem;
        cursor:default;
    }
    .header-menu-item:hover{
        color: #106eea;
        cursor:pointer;
    }
    .header-menu-item.active {
        color: #106eea;
        // font-weight: 600;
    }
}
.header-islogin{
    display: flex;
    align-items: center;
    // border: 1px solid red;
}

.header-menu-login {
    // position: absolute;
    // right: -6.5rem;
    // top: 1.35rem;
    .login-btn {
        border: none;
        background: #fff;
        // padding: 0.5rem;
        font-size: 0.8rem;
        color: #374151;
        cursor: pointer;
        margin-right:1rem;
    }
    .register-btn{
        border: none;
        // background: #fff;
        padding: 0.4rem 0.8rem;
        font-size: 0.8rem;
        color: #fff;
        border-radius:5px;
        background-color: #0066ff;
        cursor: pointer;
    }
    .login-btn:hover {
        color: #4e92eb;
    }
}


::v-deep .el-dropdown-link{
    color: #409eff;
    cursor:pointer;
}
::v-deep .el-drawer__body{
    background-color:#106eea;   
}
</style>
<style lang="scss" scoped>
.header-navbar{
    width:100%;
    height:4rem;
    box-sizing:border-box;
    padding:0 10px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    .header-navbar-lt{
        font-size: 1.4rem;
        line-height: 4rem;
        font-weight: bold;
    }
    .header-navbar-rt{
        width:4rem;
        height:4rem;
        font-size: 2rem;
        // border:1px solid #ccc;
        text-align: center;
        line-height:4rem;
        // background-color: #fff;
    }
}
.header-menu-drawer {
    box-sizing:border-box;
    padding:7rem 0;
    
    // border: 1px solid red;
    // display: flex;
    // align-items: center;
    // position: relative;
    ul,
    li {
        padding: 0;
        margin: 0;
    }
    ul {
        // display: flex;
        // align-items: center;
    }
    li{
        list-style: none;
    }
    .header-menu-item {
        color: #fff;
        padding: 1rem;
        letter-spacing: 1px;
        cursor:default;
        border-bottom:1px solid rgba(255,255,255,.1);
    }
    // .header-menu-item:hover{
    //     color: #106eea;
    //     cursor:pointer;
    // }
    // .header-menu-item.active {
    //     color: #106eea;
    //     // font-weight: 600;
    // }
    .header-mobile-login{
        width:100%;
        height:3rem;
        padding:0 1rem;
        color:#fff;
        line-height:3rem;
        // display: flex;
        // justify-content: space-between;    
        .mobile-btn{
            width:100%;
            height:3rem;
            margin:10px 0;
            border:none;
            outline: none;
            color:#333;
            background-color: #fff;
        }
    }
}
</style>
<style scoped>
@media screen and (max-width: 1600px) {
    .header-wrapper{
        width:80%;
    }
}
@media screen and (max-width: 1280px) {
    .header-wrapper{
        width:80%;
    }
}
@media screen and (max-width: 1366px) {
    .header-wrapper{
        width:80%;
    }
}
</style>